const componentLoaders = [
  ['overflow-list', () => import('@theme/overflow-list')],
  ['quick-add-component, quick-add-dialog', () => import('@theme/quick-add')],
  ['dialog-component', () => import('@theme/dialog')],
  ['variant-picker', () => import('@theme/variant-picker')],
  ['product-card, product-card-link', () => import('@theme/product-card')],
  ['product-form-component, add-to-cart-component', () => import('@theme/product-form')],
  ['accordion-custom', () => import('@theme/accordion-custom')],
  ['deferred-media, product-model', () => import('@theme/media')],
  ['product-price', () => import('@theme/product-price')],
  ['product-sku-component', () => import('@theme/product-sku')],
  ['product-inventory', () => import('@theme/product-inventory')],
  ['show-more-component', () => import('@theme/show-more')],
  ['slideshow-component', () => import('@theme/slideshow')],
  ['layered-slideshow-component', () => import('@theme/layered-slideshow')],
  ['anchored-popover-component', () => import('@theme/anchored-popover')],
  ['floating-panel-component', () => import('@theme/floating-panel')],
  ['video-background-component', () => import('@theme/video-background')],
  ['quantity-selector-component', () => import('@theme/component-quantity-selector')],
  ['media-gallery', () => import('@theme/media-gallery')],
  ['rte-formatter', () => import('@theme/rte-formatter')],
  ['volume-pricing', () => import('@theme/volume-pricing')],
  ['price-per-item', () => import('@theme/price-per-item')],
  ['volume-pricing-info', () => import('@theme/volume-pricing-info')],
];

const loadedSelectors = new Set();

function containsComponent(root, selector) {
  return root instanceof Element && root.matches(selector) ? true : Boolean(root.querySelector?.(selector));
}

function loadComponents(root) {
  for (const [selector, load] of componentLoaders) {
    if (loadedSelectors.has(selector) || !containsComponent(root, selector)) continue;

    loadedSelectors.add(selector);
    load().catch(() => loadedSelectors.delete(selector));
  }
}

loadComponents(document);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element) loadComponents(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', (event) => loadComponents(event.target));
